import APIService from '@/api/DeprecatedAPIService'
import { apiEntities } from '@/api/Helpers'
import { indexItemsById } from '@/helpers/IndexHelpers'

export interface MembershipRules {
  rules: MembershipRuleEntity[]
  ticketTypes: TicketType[]
  indexedTypes: Dict<TicketType>
}

export function getMembershipRules(): Promise<MembershipRules> {
  return APIService.getCached<'membership_rules' | 'ticket_type'>('membership_rules', {
    _embed: 'ticket_type',
    _limit: 1000,
  }).then((response) => {
    const entities = apiEntities(response)
    return {
      rules: entities.membership_rules,
      ticketTypes: entities.ticket_type,
      indexedTypes: indexItemsById(entities.ticket_type),
    }
  })
}
